<template>
  <div :style="{ height: height }">
    <QPageSticky
      :position="position"
      :expand="expand"
      :class="[
        'sai-page-sticky',
        { 'desktop-single-column': singleColumnDesktopWidth }
      ]"
    >
      <QTabs
        class="sai-tabs text-weight-medium text-label q-px-sm"
        :value="value"
        :align="align"
        :breakpoint="0"
        indicator-color="transparent"
        @input="$emit('input', $event)"
      >
        <QTab
          :class="[
            'q-px-none col q-px-sm white-space-break',
            {
              'text-grey-6': !isTabActive(tab),
              'text-primary': isTabActive(tab)
            }
          ]"
          content-class="q-py-md full-width"
          v-for="(tab, index) in tabs"
          :disable="disable || tab.disable"
          :key="tab[tabKey]"
          :name="tab[tabKey]"
          :label="tab[tabLabel]"
          :ripple="false"
          :no-caps="true"
          @click="$emit('click:tab', tab.name)"
        >
          <div
            class="bg-grey-4 full-width absolute-top rounded-borders"
            style="height: 3px"
          >
            <div
              class="bg-primary full-height rounded-borders absolute-left"
              :style="{ width: `${tab.progress}%` }"
            />
          </div>
          <QIcon
            v-if="index + 1 < tabs.length"
            name="eva-arrow-ios-forward-outline"
            class="absolute-right separator-icon"
            color="grey-4"
            size="16px"
          />
        </QTab>
      </QTabs>
    </QPageSticky>
  </div>
</template>

<script>
import { QPageSticky, QTabs, QTab, QIcon } from 'quasar';

export default {
  name: 'SAIStickyPageTabs',
  props: {
    value: undefined,
    singleColumnDesktopWidth: Boolean,
    height: {
      type: String,
      default: '60px'
    },
    displayProgressBar: Boolean,
    position: {
      type: String,
      default: 'top'
    },
    expand: {
      type: Boolean,
      default: true
    },
    tabs: {
      type: Array,
      default: () => []
    },
    align: {
      type: String,
      default: 'center'
    },
    tabKey: {
      type: String,
      default: 'name'
    },
    tabLabel: {
      type: String,
      default: 'label'
    },
    disable: Boolean
  },
  methods: {
    isTabActive(tab = {}) {
      const tabValue = tab[this.tabKey];
      const tabProgress = tab.progress || 0;
      return this.value === tabValue || tabProgress > 0;
    }
  },
  components: {
    QPageSticky,
    QTabs,
    QTab,
    QIcon
  }
};
</script>

<style lang="sass" scoped>
.sai-page-sticky::v-deep
  z-index: 1000

  .q-tabs
    background: white
    width: 100%
    border-radius: 0

.sai-tabs::v-deep
  .q-focus-helper
    opacity: 0 !important

.separator-icon
  margin: auto -16px auto auto
</style>
